import React, {useMemo} from 'react'
import styles from './DevCardStats.module.scss'
import {useUIGameEndContext} from '../../../../../contexts/UIGameEndContext'
import {BarChart} from '../../BarChart'
import {CardDataController} from '@colonist/game-card-types'
import {UIGameCard} from '../../../../../common/UIGameCard'
import {T} from '@colonist/ui'
import {CardEnum} from '@colonist/game-states'
import {useGameStore} from '../../../../../store/GameStoreContext'

export const DevCardStats = () => {
    const {gameEndData} = useUIGameEndContext()
    const activeDevelopmentAndProgressCardTypes = useGameStore((state) => state.gameMode.activeDevelopmentAndProgressCardTypes)
    const translationKeyContext = useGameStore((state) => state.gameMode.translationKeyContext)
    const activeDevelopmentCards = CardDataController.getCardEnumsOfTypes(activeDevelopmentAndProgressCardTypes)

    const resourceCardsCountMap = useMemo(() => {
        const countMap: {[key in CardEnum]?: number} = {}

        gameEndData.endGameState.developmentCardStats.forEach((num) => {
            if(countMap[num] === undefined) {
                countMap[num] = 0
            }
            countMap[num] += 1
        })

        return countMap
    }, [gameEndData])

    const chartData = useMemo(() => activeDevelopmentCards.map((cardId) => ({
        label: <UIGameCard
            cardEnum={cardId}
            className={styles.card}
            showTipTitle
        />,
        value: resourceCardsCountMap[cardId] ?? 0,
    })), [activeDevelopmentCards, resourceCardsCountMap])

    return (
        <div className={styles.container}>
            <div className={styles.title}>
                <T id={{key: 'strings:game.endGame.devCards.cardsDrawn', options: {
                    context: translationKeyContext,
                }}} />
            </div>
            <BarChart chartData={chartData} />
        </div>
    )
}
